import { motion } from "framer-motion";

const STATEMENTS = [
  { n: "01", lines: ["MOST PEOPLE BUILD", "A LIFE THAT", "LOOKS RIGHT."] },
  { n: "02", lines: ["SAFE.", "PREDICTABLE.", "ACCEPTABLE."] },
  {
    n: "03",
    lines: ["AND THEN THEY SPEND YEARS", "IGNORING THE FEELING", "THAT SOMETHING IS OFF."],
  },
];

const Block = ({ item, align }) => {
  return (
    <div
      className={`min-h-[68vh] flex items-center ${
        align === "right" ? "justify-end text-right" : "justify-start text-left"
      }`}
    >
      <motion.div
        className="max-w-4xl"
        initial={{ opacity: 0, y: 34 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.55 }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      >
        <span className="font-sans text-xs tracking-[0.4em] text-rust block mb-6">
          {item.n}
        </span>
        <h3 className="font-serif uppercase leading-[0.98] tracking-tight text-bone text-4xl sm:text-6xl lg:text-7xl">
          {item.lines.map((l, i) => (
            <span key={i} className="block">
              {l}
            </span>
          ))}
        </h3>
      </motion.div>
    </div>
  );
};

export const Manifesto = () => {
  return (
    <section
      data-testid="manifesto-section"
      className="relative bg-ink-pure py-20 sm:py-28"
    >
      <div className="mx-auto max-w-[1500px] px-6 sm:px-10 flex flex-col">
        <Block item={STATEMENTS[0]} align="left" />
        <Block item={STATEMENTS[1]} align="right" />
        <Block item={STATEMENTS[2]} align="left" />
      </div>
    </section>
  );
};
